/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import validator              from 'validator';

import { login, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE } from '../../../redux/actions/user';

import TextInput from '@fyresite/react-textinput'
import Button from '../../../components/Button'

class Login extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: {
        value: '',
        valid: '',
      },
      password: {
        value: '',
        valid: '',
      }
    };
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.state.email.valid) {
      this.email.focus()
    } else if (!this.state.password.valid) {
      this.password.focus()
    } else {
      // method inside of /redux/actions/user
      this.props.login(this.state.email.value, this.state.password.value)
        .then(action => {
          if (action.type === USER_LOGIN_SUCCESS) {
            // Swtich router to dashboard
            this.props.history.push('/dashboard');
          } else if(action.type === USER_LOGIN_FAILURE){
            // The message comes from the database
            Materialize.toast(action.payload.message, 4000, 'red');
          }
        });
    }
  }

  onChange(field, e, inputState) {
    let state = Object.assign({}, this.state);

		state[field] = Object.assign({}, state[field], inputState);

    this.setState((prevState, props) => {
      return state;
    });
  }

  render() {
    return (
      <div className="login">
        <div className="card-wrapper">
          <div className="card-container">

            <div className="login-card card z-depth-5" ref="login-card">
              <div className="card-content">
                <span className="card-title">AlphaScrip Web Portal</span>

                <form onSubmit={this.handleSubmit.bind(this)} className="left-align" noValidate>

                  <TextInput
                    ref={input => this.email = input}
                    className=""
                    inputClassName=""
                    label="Email"
                    type="email"
                    onChange={this.onChange.bind(this, "email")}
                    value={this.state.email.value}
                    valid={this.state.email.valid}
                    validator={val => { return validator.isEmail(val) }}
                    error="Must enter a valid email" />


                  <TextInput
                    ref={input => this.password = input}
                    className=""
                    inputClassName=""
                    label="Password"
                    type="password"
                    onChange={this.onChange.bind(this, "password")}
                    value={this.state.password.value}
                    valid={this.state.password.valid}
                    validator={val => { return val.length > 1 }}
                    error="" />

                  <Button
                    color={'red'}
                    flat={false}
                    onClick={this.handleSubmit.bind(this)}
                    z-depth={1}>
                    {"Login"}
                  </Button>

                  <Button
                    color={null}
                    flat={true}
                    onClick={ e => this.props.history.push('/send-password-reset') }
                    z-depth={1}>
                    {"Reset Password"}
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/Home/Login/Login.js